import { UserApi } from 'api-typings/users/users';
import { User } from './users.model';

export function transformUser(user: UserApi): User {
  if (
    !user.id ||
    !user.username ||
    !user.avatar_cdn ||
    !user.avatar_large_cdn ||
    !user.role
  ) {
    throw new ReferenceError(`Missing a required user field.`);
  }

  const displayName: string =
    user.support_status && user.support_status.short_name
      ? user.support_status.short_name
      : user.public_name || user.display_name || user.username;
  const onlineOfflineStatus = user.online_offline_status
    ? {
        status: user.online_offline_status.status,
        lastUpdatedTimestamp: user.online_offline_status.last_updated_timestamp
          ? user.online_offline_status.last_updated_timestamp * 1000
          : undefined,
      }
    : undefined;
  return {
    id: user.id,
    avatar: transformUserImage(user.avatar_cdn),
    avatarLarge: transformUserImage(user.avatar_large_cdn),
    supportStatus: user.support_status
      ? {
          type: user.support_status.type,
          shortName: user.support_status.short_name,
        }
      : undefined,
    username: user.username,
    displayName,
    role: user.role,
    chosenRole: user.chosen_role,
    profileUrl: `/u/${user.username}`,
    onlineOfflineStatus,
  };
}

export function transformUserImage(image: string): string | undefined {
  return !image.endsWith('/img/unknown.png') ? image : undefined;
}
